import type { ConceptDef } from '../types';

export const sortByFunction: ConceptDef = {
  kind: 'tileMatch',
  id: 'sort-by-function',
  label: 'Sort by Function',
  category: 'Sorting',
  description: 'Hear a function group; tap an item used for that.',
  config: {
    promptMode: 'AUDIO',
    tileCount: 4,
    items: [
      { say: 'used to write', answer: '✏ pencil' },
      { say: 'used to eat', answer: '🍴 fork' },
      { say: 'used to sit', answer: '🪑 chair' },
      { say: 'used to drink', answer: '🥛 cup' },
      { say: 'used to read', answer: '📕 book' },
    ],
  },
};
